import axios from './axios'
import config from '../config'
import NewsSection from '../components/sections/NewsSection'
import NewsSectionPreview from '../components/sections/NewsSectionPreview'
import NewsSectionConfigForm from '../components/sections/NewsSectionConfigForm'
import PieSection from '../components/sections/PieSection'
import PieSectionPreview from '../components/sections/PieSectionPreview'
import PieSectionConfigForm from '../components/sections/PieSectionConfigForm'
import StatSection from '../components/sections/StatSection'
import StatSectionPreview from '../components/sections/StatSectionPreview'
import StatSectionConfigForm from '../components/sections/StatSectionConfigForm'

const sectionTypes = [
    {
        type: 'news',
        typeName: '资讯栏目',
        component: NewsSection,
        preview: NewsSectionPreview,
        config: NewsSectionConfigForm
    },
    {
        type: 'pie',
        typeName: '饼图栏目',
        component: PieSection,
        preview: PieSectionPreview,
        config: PieSectionConfigForm
    },
    {
        type: 'stat',
        typeName: '统计图栏目',
        component: StatSection,
        preview: StatSectionPreview,
        config: StatSectionConfigForm
    },
]

const sectionTypeMap = new Map()
for (const sectionType of sectionTypes) {
    sectionTypeMap.set(sectionType.type, sectionType)
}

export default {
    getSectionType(type) {
        return sectionTypeMap.get(type)
    },
    getSectionTypes() {
        return sectionTypes
    },
    async getAssignedSectionTypes(){
        const response = await axios({
            url: config.backendUrl + '/common/sections/assigned-types',
            method: 'GET',
        })
        return response.data.map(item => sectionTypeMap.get(item))
    }
}
